import { useSyncExternalStore } from 'react';

const canMatchMedia = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

/** Reactive `window.matchMedia` for layout decisions CSS alone can't express. */
export function useMediaQuery(query: string) {
  return useSyncExternalStore(
    (onChange) => {
      if (!canMatchMedia()) {
        return () => {};
      }

      const media = window.matchMedia(query);
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    },
    () => (canMatchMedia() ? window.matchMedia(query).matches : false),
    () => false,
  );
}
